import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'airports' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
